import { NavigateFunction } from 'react-router-dom';

const History = {
  navigate: null as unknown as NavigateFunction,
};

export default History;
